'use client';

import clsx, { ClassValue } from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import OSCheck from '../../utils/OSCheck';

const currentOS = OSCheck();

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

function GoTopBtn() {
  const [isShow, setIsShow] = useState(false);

  const scrollToTop = () => {
    const mainPageElement = document.getElementById(
      'Landing',
    ) as HTMLElement | null;

    if (mainPageElement) {
      mainPageElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const mainPageElement = document.getElementById(
      'Landing',
    ) as HTMLElement | null;

    const handleScroll = () => {
      if (mainPageElement) {
        setIsShow(mainPageElement.scrollTop > 500);
      }
    };

    if (mainPageElement) {
      mainPageElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (mainPageElement) {
        mainPageElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <>
      {isShow && (
        <div
          onClick={scrollToTop}
          className='cursor-pointer fixed bottom-[20px] right-4 z-10 flex items-center justify-center rounded-full border-[0.5px] border-black border-opacity-20 bg-black bg-opacity-50 p-2.5'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
          >
            <g clip-path='url(#clip0_2240_98635)'>
              <path
                d='M11.001 5.5835V18.4168'
                stroke='white'
                stroke-width='1.1'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M16.501 11.0835L11.001 5.5835'
                stroke='white'
                stroke-width='1.1'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M5.5 11.0835L11 5.5835'
                stroke='white'
                stroke-width='1.1'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_2240_98635'>
                <rect width='22' height='22' fill='white' />
              </clipPath>
            </defs>
          </svg>
        </div>
      )}
    </>
  );
}

function GETSection02() {
  return (
    <div className='mt-[40px] flex w-full flex-col items-start justify-start px-[20px]'>
      <div className='flex w-full flex-col items-start justify-start gap-[30px] pb-[30px] text-[#222] max-w-[810px] mx-auto'>
        <h4 className='text-[20px] font-[600] leading-[30px]'>
          입점을 위한 라이선스 구매 및 <br />
          사전 예약을 하면 어떤 혜택이 있나요?
        </h4>
        <p className='max-w-[280px] break-keep text-start text-[14px] leading-[21px]'>
          사전 예약 기간에는 입점 준비 단계를 미리 등록 및 설정하여 GRAND OPEN
          (2025년 1월 31일)일정에 맞추어 자동으로 판매 서비스가 진행될 수 있도록
          준비하는 필수 세팅 기간입니다.
        </p>
      </div>
      <div className='mb-[20px] w-full rounded-[16px] bg-[#FFFFFF66] bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/m_brochureSection02Bg01.png)] bg-cover bg-center font-NanumSquareRound bg-blend-lighten'>
        <div className='relative w-full rounded-[16px] px-[12px] py-[30px] backdrop-blur-[40px]'>
          <div className='mb-[30px] flex w-full items-center justify-center gap-[20px] text-[14px] font-[700] leading-[14px]'>
            <span className='relative w-full flex-1 after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:h-[1px] after:w-full after:bg-[#555] after:content-[""]'></span>
            <span className='inline-flex shrink-0 items-center justify-center'>
              코딜몰 판매자 프로그램
            </span>
            <span className='relative w-full flex-1 after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:h-[1px] after:w-full after:bg-[#555] after:content-[""]'></span>
          </div>
          <h5 className='mb-[24px] flex flex-col items-center justify-center text-[20px] font-[800] leading-[30px]'>
            코딜몰이기에 가능한{' '}
            <span className='text-[#0575E6]'>국내 최저 수수료</span>
          </h5>
          <ul className='flex w-full flex-col items-center justify-center gap-[10px] max-w-[500px] mx-auto'>
            <li className='relative z-0 flex min-h-[180px] w-full flex-col items-start justify-start rounded-[10px] border-[1.5px] border-[#96CAFF] bg-gradient-to-b from-[#FFFFFF80] to-[#FFFFFFE5] p-[20px]'>
              <span className='mb-[10px] text-[16px] font-[800] leading-[16px] text-[#0575E6]'>
                01
              </span>
              <strong className='mb-4 text-[18px] font-[800] leading-[18px] text-[#222] tiny:text-[16px]'>
                국내 최저 수수료
              </strong>
              <p className='text-[15px] font-[400] leading-[22px] text-[#222] tiny:text-[13px]'>
                PG + 서버 + 매출 등급별 수수료
                <br />= 코딜몰에서는 모두 0%
              </p>
              <img
                src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/brochureSection02Item01.png'
                alt='국내최저수수료'
                className='absolute bottom-[17px] right-[23px] -z-[10] h-[47px] object-contain'
              />
            </li>
            <li className='relative z-0 flex min-h-[180px] w-full flex-col items-start justify-start rounded-[10px] border-[1.5px] border-[#96CAFF] bg-gradient-to-b from-[#FFFFFF80] to-[#FFFFFFE5] p-[20px]'>
              <span className='mb-[10px] text-[16px] font-[800] leading-[16px] text-[#0575E6]'>
                02
              </span>
              <strong className='mb-4 text-[18px] font-[800] leading-[18px] text-[#222] tiny:text-[16px]'>
                메인 노출 기회 제공
              </strong>
              <p className='text-[15px] font-[400] leading-[22px] text-[#222] tiny:text-[13px]'>
                내 상품을 돋보이게 할 <br />
                전용 구좌 노출
              </p>
              <img
                src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/brochureSection02Item02.png'
                alt='메인노출기회제공'
                className='absolute bottom-[17px] right-[23px] -z-[10] h-[67px] object-contain'
              />
            </li>
            <li className='relative z-0 flex min-h-[180px] w-full flex-col items-start justify-start rounded-[10px] border-[1.5px] border-[#96CAFF] bg-gradient-to-b from-[#FFFFFF80] to-[#FFFFFFE5] p-[20px]'>
              <span className='mb-[10px] text-[16px] font-[800] leading-[16px] text-[#0575E6]'>
                03
              </span>
              <strong className='mb-4 text-[18px] font-[800] leading-[18px] text-[#222] tiny:text-[16px]'>
                브랜드 콘텐츠 제작 기회 제공
              </strong>
              <p className='text-[15px] font-[400] leading-[22px] text-[#222] tiny:text-[13px]'>
                전문 에디터의 도움으로 <br />
                상품/브랜드별 콘텐츠 스토리 제작
              </p>
              <img
                src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/brochureSection02Item03.png'
                alt='브랜드콘텐츠제작기회제공'
                className='absolute bottom-[17px] right-[23px] -z-[10] h-[49px] object-contain'
              />
            </li>
            <li className='relative z-0 flex min-h-[180px] w-full flex-col items-start justify-start rounded-[10px] border-[1.5px] border-[#96CAFF] bg-gradient-to-b from-[#FFFFFF80] to-[#FFFFFFE5] p-[20px]'>
              <span className='mb-[10px] text-[16px] font-[800] leading-[16px] text-[#0575E6]'>
                04
              </span>
              <strong className='mb-4 text-[18px] font-[800] leading-[18px] text-[#222] tiny:text-[16px]'>
                프론트 노출 구좌 혜택 지원
              </strong>
              <p className='text-[15px] font-[400] leading-[22px] text-[#222] tiny:text-[13px]'>
                다양한 상품 전시를 위한
                <br />
                추가 구좌 제공
              </p>
              <img
                src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/brochureSection02Item04.png'
                alt='프론트노출구좌혜택지원'
                className='absolute bottom-[17px] right-[23px] -z-[10] h-[62px] object-contain'
              />
            </li>
          </ul>
        </div>
      </div>
      <div className='mb-[40px] w-full rounded-[16px] bg-[#FFFFFF66] bg-[url("https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/frontShow-bgImg.png")] bg-cover bg-center font-NanumSquareRound bg-blend-lighten'>
        <div className='relative w-full rounded-[16px] py-[40px] backdrop-blur-[40px]'>
          <div className='mb-[20px] flex w-full items-center justify-center gap-[20px] px-[12px] text-[14px] font-[700] leading-[14px]'>
            <span className='relative w-full flex-1 after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:h-[1px] after:w-full after:bg-[#555] after:content-[""]'></span>
            <span className='inline-flex shrink-0 items-center justify-center'>
              프론트 노출 구좌
            </span>
            <span className='relative w-full flex-1 after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:h-[1px] after:w-full after:bg-[#555] after:content-[""]'></span>
          </div>
          <div className='flex justify-center items-center text-[13px] leading-[17px] font-[700] font-NanumSquareRound mb-[37px] px-[28px]'>
            <span className='text-center break-keep'>
              입점 라이선스 사전 예약 시
              <span className='text-[#0575E6] ml-1'>
                <br />
                추가 노출 혜택을 제공
              </span>
              합니다.
            </span>
          </div>
          <ul className='flex w-full flex-col items-center justify-start gap-[10px] max-w-[500px] mx-auto'>
            <li className='flex flex-col items-center justify-start gap-[25px]'>
              <div className='relative inline-flex items-center justify-center pb-[10px] text-[14px] font-[800] leading-[22.4px] after:absolute after:bottom-0 after:left-0 after:right-0 after:mx-auto after:h-[3px] after:w-[48px] after:bg-[#222] after:content-[""]'>
                메인 배너
              </div>
              <div className='inline-flex w-full items-center justify-center px-[30px] pb-[50px] pt-[10px]'>
                <img
                  src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/frontShow-mock01.png'
                  alt='메인배너 목업'
                  className='aspect-[275/555] w-[calc(100%+30px)] min-w-[210px] overflow-hidden rounded-[11vw] md:rounded-[70px] lg:rounded-[70px] xl:rounded-[70px] 2xl:rounded-[70px] bg-gradient-to-bl from-[#ffffff2f] to-[#00000029] object-contain shadow-[-20px_40px_100px_#0000004D]'
                />
              </div>
            </li>
            <li className='flex flex-col items-center justify-start gap-[25px]'>
              <div className='relative inline-flex items-center justify-center pb-[10px] text-[14px] font-[800] leading-[22.4px] after:absolute after:bottom-0 after:left-0 after:right-0 after:mx-auto after:h-[3px] after:w-[48px] after:bg-[#222] after:content-[""]'>
                중간 배너, 상시 배너
              </div>
              <div className='inline-flex w-full items-center justify-center px-[30px] pb-[50px] pt-[10px]'>
                <img
                  src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/frontShow-mock02.png'
                  alt='상시배너 목업'
                  className='aspect-[275/555] w-[calc(100%+30px)] min-w-[210px] overflow-hidden rounded-[11vw] md:rounded-[70px] lg:rounded-[70px] xl:rounded-[70px] 2xl:rounded-[70px] bg-gradient-to-bl from-[#ffffff2f] to-[#00000029] object-contain shadow-[-20px_40px_100px_#0000004D]'
                />
              </div>
            </li>
            <li className='flex flex-col items-center justify-start gap-[25px]'>
              <div className='relative inline-flex items-center justify-center pb-[10px] text-[14px] font-[800] leading-[22.4px] after:absolute after:bottom-0 after:left-0 after:right-0 after:mx-auto after:h-[3px] after:w-[48px] after:bg-[#222] after:content-[""]'>
                추천 상품
              </div>
              <div className='inline-flex w-full items-center justify-center px-[30px] pb-[50px] pt-[10px]'>
                <img
                  src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/frontShow-mock03.png'
                  alt='추천상품 목업'
                  className='aspect-[275/555] w-[calc(100%+30px)] min-w-[210px] overflow-hidden rounded-[11vw] md:rounded-[70px] lg:rounded-[70px] xl:rounded-[70px] 2xl:rounded-[70px] bg-gradient-to-bl from-[#ffffff2f] to-[#00000029] object-contain shadow-[-20px_40px_100px_#0000004D]'
                />
              </div>
            </li>
            <li className='flex flex-col items-center justify-start gap-[25px]'>
              <div className='relative inline-flex items-center justify-center pb-[10px] text-[14px] font-[800] leading-[22.4px] after:absolute after:bottom-0 after:left-0 after:right-0 after:mx-auto after:h-[3px] after:w-[48px] after:bg-[#222] after:content-[""]'>
                브랜드
              </div>
              <div className='inline-flex w-full items-center justify-center px-[30px] pb-[50px] pt-[10px]'>
                <img
                  src='https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/frontShow-mock04.png'
                  alt='브랜드 목업'
                  className='aspect-[275/555] w-[calc(100%+30px)] min-w-[210px] overflow-hidden rounded-[11vw] md:rounded-[70px] lg:rounded-[70px] xl:rounded-[70px] 2xl:rounded-[70px] bg-gradient-to-bl from-[#ffffff2f] to-[#00000029] object-contain shadow-[-20px_40px_100px_#0000004D]'
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function GETSection03() {
  return (
    <div className='mt-[15px] flex w-full flex-col items-start justify-start px-[20px] max-w-[810px] mx-auto'>
      <div className='flex w-full flex-col items-start justify-start gap-[10px] pb-[30px] text-[#222]'>
        <h4 className='text-[20px] font-[600] leading-[30px]'>
          현재는 코딜몰 입점을 위한
          <br />
          사전 예약을 진행하고 있어요!
        </h4>
        {/* <p className='max-w-[288px] break-keep text-[14px] leading-[21px]'>
          사전 예약 기간에는 입점 준비 단계를 미리 등록 및 설정하여 GRAND OPEN
          (2025년 1월 31일)일정에 맞추어 자동으로 판매 서비스가 진행될 수 있도록
          준비하는 필수 세팅 기간입니다.
        </p> */}
      </div>
      <div className='flex w-full flex-col items-start justify-center gap-[10px] rounded-[16px] bg-[#F6F8FD] p-4 tiny:p-3'>
        <div className='w-full rounded-[10px] bg-white p-[14px] pt-[20px]'>
          <div className='mb-[20px] flex items-end justify-between'>
            <span className='break-keep text-[15px] font-[500] leading-[22.5px] tiny:text-[13px]'>
              사전 예약을 위한
              <br />
              입점 라이선스 구매 및 준비
            </span>
            <span className='text-[15px] font-[500] leading-[22.5px] tiny:text-[13px]'>
              ~2025.01.30
            </span>
          </div>
          <ul className='flex w-full flex-col items-start justify-start gap-4'>
            <li className='flex w-full flex-col items-start justify-start gap-4 rounded-[10px] bg-[#F6F8FD] p-[20px]'>
              <div className='flex items-start justify-start gap-[5px] text-[14px] font-[600] leading-[14px]'>
                <span className='text-[#0575E6] shrink-0'>STEP 01</span>
                <strong className='font-semibold '>
                  입점 라이선스 구매하기
                </strong>
              </div>
              <div className='flex w-full flex-1 flex-col items-start justify-start'>
                <strong className='mb-[6px] text-[13px] font-[500] leading-[18.2px]'>
                  입점 라이선스 결제가 필요한 이유
                </strong>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  코딜몰을 통한 매출액의 최저 수수료 도입 구매 및 구매 확정일 +
                  3일의 빠른 정산 지원
                </p>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  구매자와 판매자 사이의 불편없는 거래를 위한 실시간 문의 채팅
                  서비스를 제공합니다.
                </p>
              </div>
            </li>
            <li className='flex w-full flex-col items-start justify-start gap-4 rounded-[10px] bg-[#F6F8FD] p-[20px]'>
              <div className='flex items-start justify-start gap-[5px] text-[14px] font-[600] leading-[14px]'>
                <span className='text-[#0575E6] shrink-0'>STEP 02</span>
                <strong className='font-semibold '>사업자 정보 등록하기</strong>
              </div>
              <div className='flex w-full flex-1 flex-col items-start justify-start'>
                <strong className='mb-[6px] text-[13px] font-[500] leading-[18.2px]'>
                  가입 대상
                </strong>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  개인 사업자 또는 법인 사업자를 대상으로 실제 판매를 위해서는
                  사업자 등록 및 심사가 필요합니다.
                </p>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  사업자 등록 페이지에서 간단하게 확인/등록할 수 있습니다.
                </p>
              </div>
            </li>
            <li className='flex w-full flex-col items-start justify-start gap-4 rounded-[10px] bg-[#F6F8FD] p-[20px]'>
              <div className='flex items-start justify-start gap-[5px] text-[14px] font-[600] leading-[14px]'>
                <span className='text-[#0575E6] shrink-0'>STEP 03</span>
                <strong className='font-semibold '>
                  스토어 프로필 등록하기
                </strong>
              </div>
              <div className='flex w-full flex-1 flex-col items-start justify-start'>
                <strong className='mb-[6px] text-[13px] font-[500] leading-[18.2px]'>
                  스토어 프로필 설정
                </strong>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  스토어명, 스토어 소개, 정산 계좌 설정을 간단하게 진행할 수
                  있습니다.
                </p>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  코딜몰이 제공하는 쇼핑몰 솔루션으로 단골고객을 만들 수 있어요.
                </p>
              </div>
            </li>
            <li className='flex w-full flex-col items-start justify-start gap-4 rounded-[10px] bg-[#F6F8FD] p-[20px]'>
              <div className='w-full flex items-start justify-start gap-[5px] text-[14px] font-[600] leading-[14px]'>
                <span className='text-[#0575E6] shrink-0'>STEP 04</span>
                <strong className='font-semibold   w-full flex-1'>
                  상품 등록
                </strong>
              </div>
              <div className='flex w-full flex-1 flex-col items-start justify-start'>
                <strong className='mb-[6px] text-[13px] font-[500] leading-[18.2px]'>
                  간단한 등록
                </strong>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  쇼핑몰에서 판매할 상품을 다양한 속성을 통해 등록할 수
                  있습니다.
                </p>
                <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                  판매 권한 신청이 완료된 건강기능식품 관련, 의료기기, 전통주 등
                  관련 상품도 등록할 수 있습니다.
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div className='w-full rounded-[10px] bg-[#EBF1FF] p-[14px] pt-[20px]'>
          <div className='mb-[20px] flex items-end justify-between text-[#0575E6]'>
            <span className='break-keep text-[15px] font-[500] leading-[22.5px] tiny:text-[13px]'>
              GRAND OPEN
            </span>
            <span className='text-[15px] font-[500] leading-[22.5px] tiny:text-[13px]'>
              2025.01.31~
            </span>
          </div>
          <div className='flex w-full flex-col items-start justify-start gap-4 rounded-[10px] bg-[#F6F8FD] p-[20px]'>
            <div className='flex items-start justify-start gap-[5px] text-[14px] font-[600] leading-[14px]'>
              <span className='text-[#0575E6] shrink-0'>STEP 05</span>
              <strong className='font-semibold'>판매 서비스 시작</strong>
            </div>
            <div className='flex w-full flex-1 flex-col items-start justify-start'>
              <strong className='mb-[6px] text-[13px] font-[500] leading-[18.2px]'>
                매출의 비밀은 상품 진열
              </strong>
              <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                내 상품에 맞는 전략적인 상품 카테고리 구성으로 진열할 수
                있습니다.
              </p>
              <p className='relative pl-[16px] text-[14px] leading-[21px] text-[#555555] after:absolute after:bottom-0 after:left-0 after:top-0 after:my-auto after:content-["•"]'>
                입점된 스토어별 상품 전체보기를 통해 나의 비즈니스에 더 많은
                고객을 만날 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function GETKodealCardBanner() {
  return (
    <a
      href={'https://kodeal.fks.co.kr/m/sellerCenter/v2'}
      className="relative flex aspect-[335/200] mx-auto w-full max-w-[770px] cursor-pointer flex-col justify-between rounded-[16px] bg-[url('https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/banner_kodeal_1.png')] bg-cover bg-center bg-no-repeat"
    >
      <div className='p-5'>
        <div className='font-NanumSquareRound text-[16px] font-extrabold leading-[16px] tracking-[-0.4px] text-[#FFFFFF]'>
          코딜몰 입점
        </div>
        <div className='mt-3 text-[14px] font-normal leading-[21px] tracking-[-0.35px] text-[#FFFFFF] tiny:mt-1.5 tiny:text-[12px]'>
          이보다 더 파격적일 순 없다! 국내 최초
          <br />
          PG · 서버 · 매출 등급별 수수료 0원!
          <br />
          부담 없는 입점 조건, 증가하는 회원 수!
          <br />
          사전 예약하시면 더 없이 유리합니다!
        </div>
      </div>
      <div>
        <div className='absolute bottom-0 flex h-[22%] w-full items-center justify-center'>
          <span className='text-[14px] font-semibold leading-[14px] tracking-[-0.35px] text-[#FFFFFF] tiny:text-[13px]'>
            사전 예약하기
          </span>
        </div>
      </div>
    </a>
  );
}

const 카사요GIFT활용백서 = {
  init: {
    head: null,
    content: (
      <div className='flex flex-auto flex-col items-center justify-between rounded-[12px] bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bg_section1.png)] bg-cover bg-right-bottom pt-[100px]'>
        <div className='flex flex-col items-center gap-4'>
          <div className='font-NanumSquareRound text-[16.5px] font-bold leading-[100%] tracking-[-0.412px] text-[#FFF]'>
            카사요가 후원하는 캐시백 이벤트
          </div>
          <div className='font-NanumSquareRound text-[40px] font-extrabold leading-[100%] tracking-[-1px] text-[#FFF]'>
            현금 120만원
          </div>
          <div className='mt-8 flex h-[60px] cursor-pointer items-center justify-center gap-1 rounded-[12px] bg-[#0086FB] p-4 px-8'>
            <span className='font-NanumSquareRound text-[15px] font-bold leading-[15px] tracking-[-0.375px] text-white'>
              활용 에피소드 4편 보기
            </span>
            <ArrowRight className='h-4 text-white' />
          </div>
        </div>

        <div className='py-6'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='122'
            height='32'
            viewBox='0 0 122 32'
            fill='none'
          >
            <g clip-path='url(#clip0_3466_177006)'>
              <path
                d='M0 12.4922V10.9896H2.78954V10H4.62311V10.9896H7.47012V12.4922H6.43057C6.6134 12.7306 6.75445 12.9948 6.8537 13.2902C6.95295 13.5855 6.99997 13.8964 6.99997 14.228C6.99997 14.658 6.91639 15.0518 6.74922 15.4093C6.58206 15.7668 6.35221 16.0777 6.05967 16.3472C5.76714 16.6166 5.42236 16.8187 5.02013 16.9689C4.61789 17.1192 4.17386 17.1917 3.69327 17.1917C3.21267 17.1917 2.78954 17.1192 2.39775 16.9689C2.00596 16.8187 1.66119 16.6166 1.36865 16.3575C1.07612 16.0984 0.851488 15.7824 0.689549 15.4197C0.527609 15.057 0.449252 14.658 0.449252 14.228C0.449252 13.8964 0.496266 13.5855 0.595519 13.2902C0.694773 12.9948 0.835815 12.7306 1.01865 12.4922H0.00522497H0ZM11.0328 12.7254H12.7828V14.2798H11.0328V22.2642H2.81566C2.48133 22.2642 2.24103 22.1865 2.08954 22.0311C1.93805 21.8756 1.85969 21.6632 1.85969 21.399V17.9171H3.69327V20.7254H9.20444V10.456H11.038V12.7254H11.0328ZM3.69327 15.6995C3.897 15.6995 4.0955 15.658 4.28356 15.5803C4.47162 15.5026 4.64401 15.399 4.79028 15.2694C4.93654 15.1399 5.05147 14.9896 5.13505 14.8083C5.21863 14.6269 5.26042 14.4352 5.26042 14.2228C5.26042 14.0104 5.21863 13.8031 5.13505 13.6166C5.05147 13.4301 4.93654 13.2746 4.79028 13.1399C4.64401 13.0052 4.47162 12.9016 4.28356 12.829C4.0955 12.7565 3.897 12.7202 3.69327 12.7202C3.27013 12.7202 2.90969 12.8601 2.61715 13.1399C2.32462 13.4197 2.17835 13.7824 2.17835 14.2228C2.17835 14.4352 2.22014 14.6269 2.2985 14.8083C2.37686 14.9896 2.48655 15.1399 2.62237 15.2694C2.75819 15.399 2.92014 15.5026 3.10297 15.5803C3.28581 15.658 3.47909 15.6995 3.69327 15.6995Z'
                fill='white'
              />
              <path
                d='M24.6777 15.0823H25.3568V16.6264H20.6396V17.8232H24.6777V22.4191H22.8441V19.3777H14.768V17.8232H18.8061V16.6264H14.0994V15.0823H22.8441V12.1911H14.8098V10.6367H23.8471C24.1083 10.6367 24.312 10.7041 24.4583 10.8388C24.6045 10.9735 24.6829 11.16 24.6829 11.4087V15.0823H24.6777Z'
                fill='white'
              />
              <path
                d='M37.3083 16.954V15.4514H34.5606C34.3569 15.7157 34.1009 15.954 33.7979 16.1561C33.9285 16.1354 34.0591 16.1198 34.1949 16.1095C34.3307 16.0991 34.4666 16.0888 34.6024 16.0888C35.1561 16.0888 35.6733 16.1768 36.1434 16.3478C36.6136 16.5188 37.0262 16.7623 37.371 17.068C37.7158 17.3737 37.9927 17.7416 38.1912 18.1613C38.3897 18.581 38.4889 19.0421 38.4889 19.5395C38.4889 20.0369 38.3897 20.4618 38.1912 20.8815C37.9927 21.3012 37.721 21.6639 37.371 21.9696C37.021 22.2753 36.6136 22.5188 36.1434 22.7002C35.6733 22.8815 35.1561 22.9696 34.6024 22.9696C34.0486 22.9696 33.5524 22.8815 33.0875 22.7105C32.6225 22.5395 32.2255 22.2908 31.8964 21.9799C31.5673 21.6691 31.3009 21.3064 31.1128 20.8919C30.9248 20.4774 30.8307 20.0266 30.8307 19.5447C30.8307 18.9489 30.9613 18.41 31.2173 17.9333C31.4733 17.4566 31.8337 17.0628 32.2882 16.752C32.1785 16.7727 32.0636 16.7831 31.9434 16.7934C31.8233 16.8038 31.7031 16.809 31.583 16.809C31.0763 16.809 30.6009 16.7312 30.1673 16.5706C29.7337 16.41 29.3576 16.1872 29.0442 15.9022C28.7308 15.6172 28.48 15.2805 28.3024 14.897C28.1248 14.5136 28.0308 14.0888 28.0308 13.6328C28.0308 13.1768 28.1196 12.7312 28.292 12.3375C28.4643 11.9437 28.7151 11.6017 29.0285 11.3115C29.342 11.0214 29.7181 10.7934 30.1516 10.6276C30.5852 10.4618 31.0606 10.3789 31.583 10.3789C32.1315 10.3789 32.6278 10.467 33.0822 10.638C33.5367 10.809 33.9233 11.0577 34.2472 11.3685H37.3136V10.4618H39.1471V16.9592H37.3136L37.3083 16.954ZM31.5778 15.3012C31.8076 15.3012 32.0322 15.2597 32.2516 15.1768C32.471 15.0939 32.6643 14.9748 32.8367 14.8245C33.0091 14.6742 33.1449 14.4981 33.2442 14.296C33.3434 14.0939 33.3957 13.8711 33.3957 13.6224C33.3957 13.3737 33.3434 13.1302 33.2442 12.9126C33.1449 12.695 33.0091 12.5136 32.8419 12.353C32.6748 12.1924 32.4815 12.0784 32.2569 11.9955C32.0322 11.9126 31.8076 11.8711 31.5778 11.8711C31.3479 11.8711 31.1128 11.9126 30.8987 11.9955C30.6845 12.0784 30.4964 12.1976 30.3345 12.353C30.1725 12.5084 30.0419 12.695 29.9479 12.9126C29.8539 13.1302 29.8016 13.3634 29.8016 13.6224C29.8016 13.8815 29.8487 14.0991 29.9479 14.3064C30.0472 14.5136 30.1725 14.6898 30.3345 14.8349C30.4964 14.9799 30.6845 15.0939 30.8987 15.1768C31.1128 15.2597 31.3375 15.3012 31.5778 15.3012ZM34.6024 21.4152C34.8688 21.4152 35.13 21.3737 35.3807 21.2856C35.6315 21.1976 35.8509 21.0732 36.0494 20.9074C36.2479 20.7416 36.3994 20.5447 36.5143 20.3167C36.6292 20.0888 36.6867 19.8297 36.6867 19.5447C36.6867 19.2442 36.6292 18.9748 36.5143 18.7416C36.3994 18.5084 36.2427 18.3116 36.0494 18.1509C35.8561 17.9903 35.6315 17.8711 35.3807 17.7882C35.13 17.7053 34.874 17.6639 34.6024 17.6639C34.3307 17.6639 34.0957 17.7053 33.8606 17.7934C33.6255 17.8815 33.4166 18.0059 33.2337 18.1665C33.0509 18.3271 32.9098 18.524 32.7949 18.7571C32.68 18.9903 32.6278 19.2546 32.6278 19.5499C32.6278 19.8452 32.6852 20.0939 32.7949 20.3219C32.9046 20.5499 33.0509 20.7468 33.2337 20.9126C33.4166 21.0784 33.6203 21.2027 33.8606 21.2908C34.1009 21.3789 34.3464 21.4204 34.6024 21.4204V21.4152ZM35.1718 13.6224C35.1718 13.6794 35.1718 13.7312 35.1666 13.7882C35.1613 13.8452 35.1561 13.8919 35.1457 13.9385H37.3083V12.8763H35.0882C35.1457 13.1147 35.1718 13.3634 35.1718 13.6172V13.6224Z'
                fill='white'
              />
              <path
                d='M51.2029 10.4553H53.0365V22.2687H44.7358C44.1507 22.2687 43.8634 22.0097 43.8634 21.4864V17.0926H45.697V18.0978H51.2081V14.2273H48.9619C48.8678 14.5693 48.7164 14.8853 48.5022 15.1755C48.288 15.4656 48.0268 15.7247 47.7186 15.9371C47.4104 16.1496 47.0604 16.3206 46.679 16.4449C46.2977 16.5693 45.885 16.6314 45.4514 16.6314C44.9447 16.6314 44.4746 16.5485 44.041 16.3827C43.6074 16.2169 43.2365 15.9941 42.9231 15.7092C42.6097 15.4242 42.3589 15.0926 42.1813 14.7195C42.0037 14.3465 41.9097 13.9423 41.9097 13.5226C41.9097 13.1029 41.9985 12.6729 42.1709 12.2895C42.3432 11.906 42.594 11.5744 42.9074 11.2895C43.2209 11.0045 43.597 10.7817 44.0253 10.6159C44.4537 10.4501 44.9291 10.3672 45.4462 10.3672C45.8693 10.3672 46.2768 10.4242 46.6529 10.5382C47.029 10.6522 47.3738 10.8128 47.682 11.02C47.9902 11.2273 48.2462 11.4708 48.4604 11.7506C48.6746 12.0304 48.8313 12.3413 48.9305 12.6781H51.2081V10.4501L51.2029 10.4553ZM45.441 15.1237C45.6708 15.1237 45.8955 15.0822 46.1149 15.0045C46.3343 14.9268 46.5276 14.818 46.6999 14.6729C46.8723 14.5278 47.0082 14.362 47.1179 14.1703C47.2276 13.9786 47.2798 13.761 47.2798 13.5226C47.2798 13.2843 47.2276 13.0511 47.1179 12.8491C47.0082 12.647 46.8723 12.4708 46.6999 12.3257C46.5276 12.1807 46.3343 12.0667 46.1096 11.9889C45.885 11.9112 45.6656 11.8698 45.441 11.8698C45.2164 11.8698 44.9865 11.9112 44.7723 11.9889C44.5582 12.0667 44.3701 12.1807 44.2082 12.3257C44.0462 12.4708 43.9156 12.647 43.8216 12.8491C43.7276 13.0511 43.6753 13.2739 43.6753 13.5226C43.6753 13.7713 43.7223 13.9786 43.8216 14.1755C43.9209 14.3724 44.0514 14.5382 44.2186 14.6781C44.3858 14.818 44.5738 14.9216 44.788 14.9993C45.0022 15.077 45.2164 15.1185 45.441 15.1185V15.1237ZM51.2029 19.6366H45.6917V20.7247H51.2029V19.6366Z'
                fill='white'
              />
              <path
                d='M66.5677 19.5289C66.5677 20.0056 66.4684 20.4512 66.2699 20.8709C66.0714 21.2906 65.7998 21.6532 65.4498 21.9641C65.0998 22.275 64.6923 22.5237 64.2222 22.6999C63.752 22.876 63.2349 22.9693 62.6811 22.9693C62.1274 22.9693 61.6311 22.8812 61.1662 22.6999C60.7013 22.5185 60.3043 22.2802 59.9752 21.9693C59.6461 21.6584 59.3797 21.3009 59.1916 20.8812C59.0035 20.4615 58.9095 20.0108 58.9095 19.5237C58.9095 18.8346 59.0767 18.2284 59.411 17.6999C59.7453 17.1714 60.1998 16.7621 60.7849 16.4667H60.6856V12.3372H55.8118V10.7828H61.6155C62.2162 10.7828 62.5192 11.047 62.5192 11.5807V11.6636H65.0737V10.4512H66.9072V16.933H65.3505C65.7371 17.2543 66.0401 17.6377 66.2543 18.0781C66.4684 18.5185 66.5729 19.0004 66.5729 19.5237L66.5677 19.5289ZM62.6811 21.4149C62.9476 21.4149 63.2087 21.3735 63.4595 21.2854C63.7102 21.1973 63.9296 21.0729 64.1281 20.9071C64.3267 20.7413 64.4781 20.5444 64.5931 20.3061C64.708 20.0678 64.7655 19.8139 64.7655 19.5289C64.7655 19.2284 64.708 18.9589 64.5931 18.7258C64.4781 18.4926 64.3214 18.2905 64.1281 18.1247C63.9349 17.9589 63.7102 17.8346 63.4595 17.7465C63.2087 17.6584 62.9528 17.617 62.6811 17.617C62.4095 17.617 62.1744 17.6636 61.9393 17.7569C61.7043 17.8501 61.4953 17.9797 61.3125 18.1403C61.1297 18.3009 60.9886 18.503 60.8737 18.7413C60.7588 18.9797 60.7065 19.2387 60.7065 19.5341C60.7065 19.8294 60.764 20.0781 60.8737 20.3113C60.9834 20.5444 61.1297 20.7465 61.3125 20.9123C61.4953 21.0781 61.6991 21.2025 61.9393 21.2906C62.1796 21.3786 62.4252 21.4201 62.6811 21.4201V21.4149ZM65.0684 13.1403H62.514V13.8968H65.0684V13.1403ZM62.6811 16.047C63.1461 16.047 63.5744 16.1092 63.9767 16.2336C64.3789 16.3579 64.7446 16.5289 65.0684 16.7517V15.4149H62.514V16.047H62.6811Z'
                fill='white'
              />
              <path
                d='M73.4377 12.4667L76.1437 17.617L74.4668 18.4823L72.4817 14.5185L70.4706 18.4823L68.8198 17.617L71.4997 12.4667H69.4467V10.9123H75.4959V12.4667H73.4429H73.4377ZM76.5877 10.4564H78.3795V22.2802H76.5877V15.0781H74.8691V13.5237H76.5877V10.4512V10.4564ZM79.184 10.4564H81.028V22.2802H79.184V10.4564Z'
                fill='white'
              />
              <path
                d='M87.082 10.3984C87.5992 10.3984 88.085 10.4813 88.5342 10.6471C88.9835 10.8129 89.3701 11.0409 89.6992 11.3363C90.0283 11.6316 90.2842 11.9787 90.4671 12.3829C90.6499 12.787 90.7439 13.2275 90.7439 13.7041C90.7439 14.1808 90.6499 14.5901 90.4618 14.9839C90.2738 15.3777 90.0126 15.7249 89.6783 16.015C89.3439 16.3052 88.9574 16.5383 88.5133 16.7041C88.0693 16.8699 87.5939 16.9528 87.082 16.9528C86.5701 16.9528 86.0999 16.8699 85.6611 16.699C85.2223 16.528 84.841 16.3 84.5171 16.0098C84.1932 15.7197 83.9372 15.3777 83.7544 14.9839C83.5716 14.5901 83.4775 14.1601 83.4775 13.7041C83.4775 13.2482 83.5663 12.8026 83.7492 12.4036C83.932 12.0047 84.1828 11.6575 84.5066 11.357C84.8305 11.0565 85.2119 10.8233 85.6507 10.6523C86.0895 10.4813 86.5701 10.3984 87.0872 10.3984H87.082ZM87.082 15.4503C87.3484 15.4503 87.5992 15.4036 87.829 15.3104C88.0589 15.2171 88.2574 15.0927 88.4245 14.9373C88.5917 14.7819 88.7223 14.5953 88.8215 14.3881C88.9208 14.1808 88.9678 13.9477 88.9678 13.699C88.9678 13.4503 88.9208 13.2015 88.8215 12.9787C88.7223 12.7559 88.5917 12.5642 88.4193 12.4088C88.2469 12.2534 88.0484 12.129 87.8133 12.0357C87.5783 11.9425 87.338 11.8958 87.0768 11.8958C86.8156 11.8958 86.5753 11.9425 86.3559 12.0357C86.1365 12.129 85.938 12.2534 85.7708 12.4088C85.6036 12.5642 85.4731 12.7559 85.3843 12.9787C85.2954 13.2015 85.2432 13.4451 85.2432 13.699C85.2432 13.9528 85.2902 14.1756 85.3843 14.3881C85.4783 14.6005 85.6037 14.787 85.7656 14.9477C85.9275 15.1083 86.1208 15.2326 86.3402 15.3207C86.5596 15.4088 86.8051 15.4503 87.0768 15.4503H87.082ZM92.8439 10.4554H94.6775V22.2689H86.4604C86.1156 22.2689 85.8753 22.1964 85.7238 22.0565C85.5723 21.9166 85.4992 21.7093 85.4992 21.4451V17.8129H87.3327V20.73H92.8439V10.4606V10.4554Z'
                fill='white'
              />
              <path
                d='M97.4775 12.4922V10.9896H100.183V10H102.017V10.9896H104.765V12.228H106.708V10.4508H108.542V22.2642H100.283C99.6716 22.2642 99.3686 21.9793 99.3686 21.4093V17.2642H101.202V18.171H106.713V16.0104H104.713V14.5233H106.713V13.7098H104.713V12.487H103.908C104.039 12.6995 104.138 12.9275 104.206 13.1762C104.274 13.4249 104.31 13.6839 104.31 13.9585C104.31 14.3627 104.232 14.7358 104.075 15.0829C103.919 15.4301 103.699 15.7306 103.417 15.9896C103.135 16.2487 102.795 16.456 102.404 16.601C102.012 16.7461 101.573 16.8238 101.092 16.8238C100.612 16.8238 100.189 16.7513 99.8022 16.601C99.4156 16.4508 99.0813 16.2487 98.8044 15.9896C98.5275 15.7306 98.3081 15.4249 98.1514 15.0829C97.9947 14.7409 97.9163 14.3627 97.9163 13.9585C97.9163 13.4093 98.0522 12.9171 98.3186 12.487H97.488L97.4775 12.4922ZM101.087 15.3005C101.281 15.3005 101.469 15.2642 101.651 15.1969C101.834 15.1295 101.986 15.0363 102.116 14.9171C102.247 14.7979 102.351 14.658 102.43 14.4974C102.508 14.3368 102.55 14.1606 102.55 13.9689C102.55 13.5648 102.409 13.2383 102.122 12.9845C101.834 12.7306 101.495 12.6062 101.092 12.6062C100.899 12.6062 100.716 12.6425 100.544 12.7098C100.372 12.7772 100.22 12.8705 100.095 12.9896C99.9693 13.1088 99.8648 13.2487 99.7917 13.4145C99.7186 13.5803 99.682 13.7617 99.682 13.9637C99.682 14.1658 99.7186 14.3368 99.7917 14.5026C99.8648 14.6684 99.9693 14.8083 100.095 14.9223C100.22 15.0363 100.377 15.1295 100.544 15.1969C100.711 15.2642 100.899 15.3005 101.092 15.3005H101.087ZM106.708 19.7202H101.197V20.7254H106.708V19.7202Z'
                fill='white'
              />
              <path
                d='M122.423 22.2634H120.589V19.7971H111.04V18.253H114.138V17.0717C113.788 16.9888 113.464 16.8541 113.171 16.6727C112.879 16.4914 112.628 16.2737 112.414 16.0199C112.199 15.766 112.032 15.4862 111.912 15.1753C111.792 14.8644 111.729 14.5328 111.729 14.1857C111.729 13.5898 111.902 13.0509 112.241 12.5743H111.228V11.0613H114.127V10.082H115.961V11.0613H118.86V12.5743H117.831C118.176 13.0406 118.343 13.5794 118.343 14.1857C118.343 14.5328 118.28 14.8644 118.16 15.1701C118.04 15.4758 117.873 15.7556 117.658 16.0043C117.444 16.253 117.193 16.4655 116.901 16.6468C116.608 16.8281 116.295 16.9629 115.95 17.0509V18.2634H120.573V10.4603H122.407V22.2737L122.423 22.2634ZM115.02 15.6572C115.214 15.6572 115.407 15.6209 115.595 15.5535C115.783 15.4862 115.955 15.3877 116.102 15.2582C116.248 15.1287 116.368 14.9732 116.457 14.7919C116.546 14.6105 116.588 14.4085 116.588 14.1857C116.588 13.9629 116.546 13.7504 116.457 13.5639C116.368 13.3774 116.253 13.2219 116.102 13.0976C115.95 12.9732 115.788 12.8696 115.6 12.8022C115.412 12.7349 115.219 12.6986 115.015 12.6986C114.811 12.6986 114.618 12.7349 114.43 12.8022C114.242 12.8696 114.085 12.968 113.944 13.0976C113.803 13.2271 113.694 13.3825 113.61 13.5639C113.526 13.7452 113.485 13.9525 113.485 14.1857C113.485 14.6261 113.631 14.9836 113.929 15.253C114.226 15.5224 114.587 15.6572 115.01 15.6572H115.02Z'
                fill='white'
              />
            </g>
            <defs>
              <clipPath id='clip0_3466_177006'>
                <rect width='122' height='32' rx='12' fill='white' />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    ),
  },
  ep1: {
    head: (
      <div className='flex h-[50px] flex-none items-center justify-between rounded-t-[12px] bg-black/40 px-5'>
        <div className='flex items-center justify-center gap-2'>
          <div className='font-NanumSquareRound text-[15px] font-extrabold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            Episode.1
          </div>
          <div className='h-[14px] w-[1px] bg-[rgba(255,255,255,0.50)]'></div>
          <div className='font-NanumSquareRound text-[15px] font-bold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            [광수] 신차 출고 편
          </div>
        </div>
        <div className='font-NanumSquareRound text-[14px] font-bold leading-[14px] tracking-[-0.35px] text-[#999999]'>
          1/4
        </div>
      </div>
    ),
    content: (
      <div className='flex h-full flex-col items-start gap-5 p-5 text-white'>
        <div className='flex gap-2'>
          <div className='h-10 w-10 flex-none rounded-full bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/profile_1.png)] bg-cover bg-center'></div>
          <div className='flex flex-auto flex-col gap-2.5'>
            <div className='font-NanumSquareRound text-[13px] font-bold leading-[13px] tracking-[-0.325px] text-white'>
              광수
            </div>
            <div className='rounded-r-[10px] rounded-bl-[10px] bg-white p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-[#222]'>
              카사요 도움으로 <br />
              신차 출고 및 등록 완료 후<br />
              담당 딜러가 협회에 계약사항을 전달했어요.
            </div>
          </div>
        </div>

        <div className='flex w-full flex-col items-end justify-start gap-2'>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [신차 구매]
            <br />
            현금 20만원 입금되었습니다.
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            잔여 캐시백 금액은 100만원입니다!
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            가족, 지인에게 소개하여
            <br />
            나머지 캐시백도 챙기세요.
          </div>
        </div>
      </div>
    ),
  },
  ep2: {
    head: (
      <div className='flex h-[50px] flex-none items-center justify-between rounded-t-[12px] bg-black/40 px-5'>
        <div className='flex items-center justify-center gap-2'>
          <div className='font-NanumSquareRound text-[15px] font-extrabold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            Episode.2
          </div>
          <div className='h-[14px] w-[1px] bg-[rgba(255,255,255,0.50)]'></div>
          <div className='font-NanumSquareRound text-[15px] font-bold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            [광수] 중고차 팔기 편
          </div>
        </div>
        <div className='font-NanumSquareRound text-[14px] font-bold leading-[14px] tracking-[-0.35px] text-[#999999]'>
          2/4
        </div>
      </div>
    ),
    content: (
      <div className='flex h-full flex-col items-start gap-5 p-5 text-white'>
        <div className='flex gap-2'>
          <div className='h-10 w-10 flex-none rounded-full bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/profile_1.png)] bg-cover bg-center'></div>
          <div className='flex flex-auto flex-col gap-2.5'>
            <div className='font-NanumSquareRound text-[13px] font-bold leading-[13px] tracking-[-0.325px] text-white'>
              광수
            </div>
            <div className='max-w-[210px] rounded-r-[10px] rounded-bl-[10px] bg-white p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-[#222]'>
              카사요 도움으로 <br />
              내 차를 중고로 처분하고
              <br />
              이전 등록증 확인 등 담당 딜러가 거래사항을 전달했어요.
              <br />
              거래(판매)금액 500만원 이상 받았어요!
            </div>
          </div>
        </div>

        <div className='flex w-full flex-col items-end justify-start gap-2'>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [중고차 팔기]
            <br />
            현금 20만원 입금되었습니다.
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            잔여 캐시백 금액은 80만원입니다!
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            가족, 지인에게 소개하여
            <br />
            나머지 캐시백도 챙기세요.
          </div>
        </div>
      </div>
    ),
  },
  ep3: {
    head: (
      <div className='flex h-[50px] flex-none items-center justify-between rounded-t-[12px] bg-black/40 px-5'>
        <div className='flex items-center justify-center gap-2'>
          <div className='font-NanumSquareRound text-[15px] font-extrabold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            Episode.3
          </div>
          <div className='h-[14px] w-[1px] bg-[rgba(255,255,255,0.50)]'></div>
          <div className='font-NanumSquareRound text-[15px] font-bold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            [옥순] 단번에 끝내기
          </div>
        </div>
        <div className='font-NanumSquareRound text-[14px] font-bold leading-[14px] tracking-[-0.35px] text-[#999999]'>
          3/4
        </div>
      </div>
    ),
    content: (
      <div className='flex h-full flex-col items-start gap-5 p-5 text-white'>
        <div className='flex gap-2'>
          <div className='h-10 w-10 flex-none rounded-full bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/profile_2.png)] bg-cover bg-center'></div>
          <div className='flex flex-auto flex-col gap-2.5'>
            <div className='font-NanumSquareRound text-[13px] font-bold leading-[13px] tracking-[-0.325px] text-white'>
              옥순
            </div>
            <div className='rounded-r-[10px] rounded-bl-[10px] bg-white p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-[#222]'>
              카사요 도움으로 <br />
              1) 내 차를 중고로 처분하고,
              <br />
              2) 신차를 계약 및 출고,
              <br />
              3) 다이렉트 자동차 보험까지 <br />
              논스톱으로 완료했어요!
            </div>
          </div>
        </div>

        <div className='flex w-full flex-col items-end justify-start gap-2'>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [중고차 팔기]
            <br />
            현금 20만원 입금되었습니다.
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [신차 구매]
            <br />
            현금 20만원 입금되었습니다.
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [다이렉트 보험 가입]
            <br />
            현금 3만원 입금되었습니다.
          </div>
        </div>
      </div>
    ),
  },
  ep4: {
    head: (
      <div className='flex h-[50px] flex-none items-center justify-between rounded-t-[12px] bg-black/40 px-5'>
        <div className='flex items-center justify-center gap-2'>
          <div className='font-NanumSquareRound text-[15px] font-extrabold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            Episode.4
          </div>
          <div className='h-[14px] w-[1px] bg-[rgba(255,255,255,0.50)]'></div>
          <div className='font-NanumSquareRound text-[15px] font-bold leading-[15px] tracking-[-0.375px] text-[#FFFFFF]'>
            [영철] 가족/지인 소개
          </div>
        </div>
        <div className='font-NanumSquareRound text-[14px] font-bold leading-[14px] tracking-[-0.35px] text-[#999999]'>
          4/4
        </div>
      </div>
    ),
    content: (
      <div className='flex h-full flex-col items-start gap-5 p-5 text-white'>
        <div className='flex gap-2'>
          <div className='h-10 w-10 flex-none rounded-full bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/profile_3.png)] bg-cover bg-center'></div>
          <div className='flex flex-auto flex-col gap-2.5'>
            <div className='font-NanumSquareRound text-[13px] font-bold leading-[13px] tracking-[-0.325px] text-white'>
              영철
            </div>
            <div className='rounded-r-[10px] rounded-bl-[10px] bg-white p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-[#222]'>
              카사요 도움으로 <br />
              <span className='text-[#0086FB]'>친구 2명을 소개</span>
              해서 <br />
              1) 신차를 계약 및 출고하고,
              <br />
              2) 친구 차는 중고로 팔고,
              <br />
              3) 다이렉트 자동차 보험까지 <br />
              논스톱으로 완료했어요!
            </div>
          </div>
        </div>

        <div className='flex w-full flex-col items-end justify-start gap-2'>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [중고차 팔기 - 2대]
            <br />
            현금 40만원 입금되었습니다.
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [신차 구매 - 2대]
            <br />
            현금 40만원 입금되었습니다.
          </div>
          <div className='rounded-l-[10px] rounded-tr-[10px] bg-[#0086FB] p-2.5 font-NanumSquareRound text-[15px] font-bold leading-[24px] tracking-[-0.375px] text-white'>
            [다이렉트 보험 가입 - 2대]
            <br />
            현금 6만원 입금되었습니다.
          </div>
        </div>
      </div>
    ),
  },
};

function Section3() {
  const radioContents = [
    {
      title: '두시탈출 컬투쇼',
      description: '[월~일] 14:00~16:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg01.png',
    },
    {
      title: '웬디의 영스트리트',
      description: '[월~일] 20:00~22:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg02.png',
    },
    {
      title: '김영철의 파워FM',
      description: '[월~일] 07:00~09:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg03.png',
    },
    {
      title: '황제성의 황제파워',
      description: '[월~일] 16:00~18:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg04.png',
    },
    {
      title: '박소현의 러브게임',
      description: '[월~일] 18:00~20:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg05.png',
    },
    {
      title: '딘딘의 뮤직하이',
      description: '[월~일] 23:00~01:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg06.png',
    },
    {
      title: '이인권의 펀펀투데이',
      description: '[월~일] 05:00~07:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg07.png',
    },
    {
      title: '박하선의 씨네타운',
      description: '[월~일] 11:00~12:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg08.png',
    },
    {
      title: '아름다운 이 아침, 봉태규입니다',
      description: '[월~일] 09:00~11:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg09.png',
    },
    {
      title: '12시엔 주현영',
      description: '[월~일] 12:00~14:00',
      imgUrl:
        'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/radio-adImg10.png',
    },
  ];
  const busImgs = [
    'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bus-adImg01.png',
    'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bus-adImg02.png',
    'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bus-adImg03.png',
    'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bus-adImg04.png',
    'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bus-adImg05.png',
    'https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bus-adImg06.png',
  ];

  return (
    <section className='pb-[34px ] w-full bg-gradient-to-r from-[#B2CEFF] to-[#EAFBFF] px-[20px] pt-[50px] text-[#222]'>
      <div className='mb-[50px]'>
        <div className='mb-[30px] flex flex-col items-center justify-center gap-4'>
          <span className='inline-flex items-center justify-center rounded-[100px] border border-[#000] px-[10px] py-2 font-NanumSquareRound text-[14px] font-[700] leading-[14px]'>
            활동 1
          </span>
          <p className='font-NanumSquareRound text-[20px] font-[800] leading-[26px] text-center break-keep'>
            24시간 인기 라디오 프로그램 CM 송출
          </p>
        </div>
        <ul className='grid grid-cols-2 md:max-w-[500px] md:mx-auto lg:max-w-[770px] xl:max-w-full 2xl:max-w-full lg:mx-auto xl:grid-cols-5 2xl:grid-cols-5 gap-x-[9px] gap-y-[30px]'>
          {radioContents.map((radio, index) => (
            <li
              key={`radioAD_${radio.title}_${index}`}
              className='flex flex-col items-start justify-start gap-1'
            >
              <div className='mb-2 aspect-[163/163] w-full overflow-hidden rounded-[8px]'>
                <img
                  src={radio.imgUrl}
                  alt={`라디오 광고 이미지_${index}`}
                  className='h-full w-full object-fill'
                />
              </div>
              <p className='text-[15px] font-[500] leading-[21px] tracking-[-0.34px]'>
                {radio.title}
              </p>
              <p className='text-[14px] font-[400] leading-[19.6px] tracking-[-0.35px]'>
                {radio.description}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div className='mb-[46px]'>
        <div className='mb-[30px] flex flex-col items-center justify-center gap-4'>
          <span className='inline-flex items-center justify-center rounded-[100px] border border-[#000] px-[10px] py-2 font-NanumSquareRound text-[14px] font-[700] leading-[14px]'>
            활동 2
          </span>
          <p className='font-NanumSquareRound text-[20px] font-[800] leading-[26px] text-center break-keep'>
            전국 버스 외부광고
          </p>
        </div>
        <ul className='grid grid-cols-1 gap-[10px] md:max-w-[500px] md:mx-auto lg:max-w-[770px]  xl:max-w-full 2xl:max-w-full lg:mx-auto xl:grid-cols-2 2xl:grid-cols-2'>
          {busImgs.map((bus, index) => (
            <li
              key={`busAD_${bus}_${index}`}
              className='aspect-[335/200] w-full overflow-hidden rounded-[8px]'
            >
              <img
                src={bus}
                alt={`버스 광고 이미지_${index}`}
                className='h-full w-full object-fill'
              />
            </li>
          ))}
        </ul>
      </div>
      <p className='w-full pb-10 text-center text-[11px] leading-[11px]'>
        Copyright ⓒ 카사요(주) ALL RIGHTS RESERVED.
      </p>
    </section>
  );
}

function Section1_Swiper() {
  const [tab, setTab] = useState<keyof typeof 카사요GIFT활용백서>('init');

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tab === 'init') return;
    if (!ref.current) return;

    ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [tab]);

  return (
    <div
      ref={ref}
      className='flex h-[580px] flex-col justify-between rounded-[12px] bg-[#333]'
    >
      <AnimatePresence mode='wait' initial={true}>
        <motion.div
          key={tab}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className='flex w-full flex-auto flex-col'
          onClick={() => {
            if (tab === 'init') return setTab('ep1');
          }}
        >
          {카사요GIFT활용백서[tab].head && 카사요GIFT활용백서[tab].head}
          {카사요GIFT활용백서[tab].content && 카사요GIFT활용백서[tab].content}
        </motion.div>
      </AnimatePresence>

      <div
        className={cn(
          'flex h-[50px] flex-none items-center justify-between divide-x divide-[#222] rounded-b-[12px] border border-[#222] font-NanumSquareRound text-[14px] font-bold leading-[22.4px] tracking-[-0.35px] text-white',
          tab === 'init' && 'hidden',
        )}
      >
        <div
          className={cn(
            'flex h-full w-full items-center justify-center gap-1 cursor-pointer',
            tab === 'ep1' && 'text-[#999999] cursor-default',
          )}
          onClick={() => {
            if (tab === 'ep4') return setTab('ep3');
            if (tab === 'ep3') return setTab('ep2');
            if (tab === 'ep2') return setTab('ep1');
          }}
        >
          <ArrowLeft className='h-4 w-4' />
          이전 에피소드
        </div>
        <div
          className={cn(
            'flex h-full w-full items-center justify-center gap-1 cursor-pointer',
            tab === 'ep4' && 'text-[#999999] cursor-default',
          )}
          onClick={() => {
            if (tab === 'ep1') return setTab('ep2');
            if (tab === 'ep2') return setTab('ep3');
            if (tab === 'ep3') return setTab('ep4');
          }}
        >
          다음 에피소드
          <ArrowRight className='h-4 w-4' />
        </div>
      </div>
    </div>
  );
}

function Section1() {
  function openAppLink() {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any)?.opera;

    if (/android/i.test(userAgent)) {
      // 안드로이드 링크
      window.open(
        'https://play.google.com/store/apps/details?id=com.carsayo.fks',
      );
    } else if (
      /iPad|iPhone|iPod/.test(userAgent) &&
      !(window as any)?.MSStream
    ) {
      // iOS 링크
      window.open(
        'https://apps.apple.com/us/app/%ED%95%9C%EA%B5%AD%EC%98%81%EC%97%85%EA%B2%BD%EC%A0%9C[…]B4%EC%BB%A4%EB%A8%B8%EC%8A%A4-%ED%8F%AC%ED%84%B8/id6737255285',
      );
    } else {
      if (currentOS === 'Windows') {
        // window 안드로이드 링크
        window.open(
          'https://play.google.com/store/apps/details?id=com.carsayo.fks&pli=1',
        );
      } else if (currentOS === 'Mac') {
        // Mac ios 링크
        window.open(
          'https://apps.apple.com/us/app/%ED%95%9C%EA%B5%AD%EC%98%81%EC%97%85%EA%B2%BD%EC%A0%9C[…]B4%EC%BB%A4%EB%A8%B8%EC%8A%A4-%ED%8F%AC%ED%84%B8/id6737255285',
        );
      }
    }
  }

  return (
    <div className='relative bg-[#E9FAFF] pb-10'>
      <div className='bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/bg_block.png)] bg-cover bg-top'>
        <div className='bg-[rgba(0,0,0,0.05)] px-5 backdrop-blur-[15px]'>
          <div className='flex h-[70px] items-center justify-between max-w-[810px] mx-auto'>
            <div className='flex gap-3 items-center'>
              <div className='rounded-[16px] bg-white p-2 aspect-[50/50] shrink-0 tiny:hidden s:hidden block'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='34'
                  height='34'
                  viewBox='0 0 34 34'
                  fill='none'
                >
                  <g clip-path='url(#clip0_3462_176815)'>
                    <path
                      d='M0.331055 16.8047L7.3326 23.8062C7.3326 23.8062 8.7937 25.2407 8.87369 25.31C9.48159 25.8486 10.0362 26.2538 10.5481 26.5578C13.433 28.2535 14.8727 26.5898 15.39 26.0992L17.427 24.0622L10.1641 16.8047H0.331055Z'
                      fill='#009DDA'
                    />
                    <path
                      d='M33.6616 16.8022L26.6601 9.80068C26.6601 9.80068 25.199 8.36625 25.119 8.29692C24.5111 7.75834 23.9565 7.35307 23.4446 7.04912C20.5597 5.35339 19.1199 7.01713 18.6027 7.50772L16.5657 9.54472L23.8285 16.8022H33.6616Z'
                      fill='#009DDA'
                    />
                    <path
                      d='M17.9222 29.3521C17.4103 29.8693 16.1838 31.1011 14.1575 30.6585C15.3146 31.8157 17.181 31.9276 18.4128 30.8558C18.6048 30.6905 18.7647 30.5252 18.898 30.3866C18.962 30.3172 19.0207 30.2586 19.0687 30.2159L29.3817 19.7589V17.7539L18.0608 29.2187C18.0182 29.2614 17.9755 29.3041 17.9222 29.3521Z'
                      fill='url(#paint0_linear_3462_176815)'
                    />
                    <path
                      d='M19.4499 30.9241C18.9433 31.4413 17.8021 32.6198 15.9998 32.5025C17.0183 33.521 18.6767 33.521 19.6952 32.5025L29.3789 22.6747V20.8457L19.6045 30.7641C19.5565 30.8121 19.5032 30.8601 19.4499 30.9241Z'
                      fill='url(#paint1_linear_3462_176815)'
                    />
                    <path
                      d='M15.8544 26.791C15.2465 27.3829 13.5508 29.0413 10.3459 26.8497L12.207 28.7107C12.7136 29.2173 13.3215 29.6225 14.0094 29.8305C15.8117 30.3851 16.8409 29.3453 17.3742 28.812C17.4275 28.7587 17.4755 28.7054 17.5181 28.668L23.1866 22.9996L24.9196 21.2665L29.3776 16.8086H16.9956L21.4162 21.2292L15.8491 26.7963L15.8544 26.791Z'
                      fill='url(#paint2_linear_3462_176815)'
                    />
                    <path
                      d='M16.0672 4.26062C16.5791 3.74337 17.8056 2.51156 19.8319 2.95416C18.6748 1.79701 16.8084 1.68503 15.5766 2.75686C15.3846 2.92216 15.2246 3.08747 15.0913 3.22612C15.0273 3.29544 14.9687 3.3541 14.9207 3.39676L4.60767 13.8538V15.8588L15.9339 4.39393C15.9765 4.35127 16.0192 4.30861 16.0725 4.26062H16.0672Z'
                      fill='url(#paint3_linear_3462_176815)'
                    />
                    <path
                      d='M14.5421 2.68409C15.0487 2.16684 16.1898 0.98836 17.9922 1.10567C16.9737 0.087171 15.3153 0.087171 14.2968 1.10567L4.60767 10.9334V12.7625L14.3821 2.84406C14.4301 2.79607 14.4834 2.74808 14.5367 2.68409H14.5421Z'
                      fill='url(#paint4_linear_3462_176815)'
                    />
                    <path
                      d='M18.1445 6.81883C18.7524 6.22693 20.4481 4.56853 23.653 6.76018L21.7919 4.89914C21.2853 4.39256 20.6774 3.98729 19.9895 3.77932C18.1872 3.22474 17.158 4.26458 16.6248 4.79782C16.5714 4.85115 16.5234 4.90447 16.4808 4.9418L10.8123 10.6102L9.07929 12.3433L4.62134 16.8012H17.0034L12.5827 12.3806L18.1498 6.8135L18.1445 6.81883Z'
                      fill='url(#paint5_linear_3462_176815)'
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id='paint0_linear_3462_176815'
                      x1='28.6725'
                      y1='18.3778'
                      x2='14.0348'
                      y2='33.0155'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='#172A88' />
                      <stop offset='0.5' stop-color='#036EB8' />
                      <stop offset='0.95' stop-color='#008ED2' />
                    </linearGradient>
                    <linearGradient
                      id='paint1_linear_3462_176815'
                      x1='30.3281'
                      y1='20.0298'
                      x2='15.6905'
                      y2='34.6675'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='#172A88' />
                      <stop offset='0.5' stop-color='#036EB8' />
                      <stop offset='0.95' stop-color='#008ED2' />
                    </linearGradient>
                    <linearGradient
                      id='paint2_linear_3462_176815'
                      x1='25.1489'
                      y1='14.8462'
                      x2='10.5059'
                      y2='29.4892'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='#172A88' />
                      <stop offset='0.5' stop-color='#036EB8' />
                      <stop offset='0.95' stop-color='#008ED2' />
                    </linearGradient>
                    <linearGradient
                      id='paint3_linear_3462_176815'
                      x1='6.85264'
                      y1='13.6991'
                      x2='20.8557'
                      y2='-0.303986'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='#172A88' />
                      <stop offset='0.5' stop-color='#036EB8' />
                      <stop offset='0.95' stop-color='#008ED2' />
                    </linearGradient>
                    <linearGradient
                      id='paint4_linear_3462_176815'
                      x1='5.19957'
                      y1='12.0426'
                      x2='19.2027'
                      y2='-1.9605'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='#172A88' />
                      <stop offset='0.5' stop-color='#036EB8' />
                      <stop offset='0.95' stop-color='#008ED2' />
                    </linearGradient>
                    <linearGradient
                      id='paint5_linear_3462_176815'
                      x1='10.3911'
                      y1='17.2225'
                      x2='24.3888'
                      y2='3.22474'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='#172A88' />
                      <stop offset='0.5' stop-color='#036EB8' />
                      <stop offset='0.95' stop-color='#008ED2' />
                    </linearGradient>
                    <clipPath id='clip0_3462_176815'>
                      <rect
                        width='33.3333'
                        height='32.9334'
                        fill='white'
                        transform='translate(0.331055 0.333984)'
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className='flex flex-col items-start justify-between py-2 gap-2'>
                <div className='text-[15px] font-semibold leading-[15px] tracking-[-0.3px] text-[#222222]'>
                  한국영업경제인협회
                </div>
                <div className='text-[13px] font-normal leading-[13px] tracking-[-0.26px] text-[#222222]'>
                  {currentOS === 'iOS' || currentOS === 'Mac'
                    ? 'App Store'
                    : 'Google Play'}
                  에서 다운받으세요.
                </div>
              </div>
            </div>
            <div
              onClick={() => {
                openAppLink();
              }}
              className='shrink-0 cursor-pointer rounded-[8px] bg-[#4556ED] px-3 py-2.5 text-center text-[15px] font-semibold leading-[15px] tracking-[-0.3px] text-[#FFFFFF]'
            >
              앱 다운받기
            </div>
          </div>
        </div>

        {/* 카사요 GIFT 활용 백서 */}
        <div className='flex flex-col px-5 max-w-[810px] mx-auto'>
          <div className='py-6 pt-10 text-center font-NanumSquareRound text-[24px] font-extrabold leading-[31.2px] tracking-[-0.6px] text-[#222222]'>
            카사요 GIFT 활용 백서
          </div>

          <Section1_Swiper />

          <a
            href={'https://kodeal.fks.co.kr/m/carsayoGift/pay'}
            className='mt-5 flex h-[60px] cursor-pointer flex-col items-center justify-center rounded-[12px] bg-[#4556ED]'
          >
            <span className='text-center text-[15px] font-semibold leading-[15px] tracking-[-0.3px] text-[#FFFFFF]'>
              카사요 GIFT 구매하기
            </span>
          </a>
        </div>

        {/* 카사요 GIFT 활용 백서 */}
        <div className='flex flex-col px-5 max-w-[810px] mx-auto'>
          <div className='py-6 pt-20 text-center font-NanumSquareRound text-[24px] font-extrabold leading-[31.2px] tracking-[-0.6px] text-[#222222]'>
            코딜몰 마켓 플레이스
          </div>

          <div className='flex flex-col justify-between rounded-[12px]'>
            <div className='aspect-[335/210] max-h-[210px] w-full rounded-t-[12px] bg-[url(https://carsayo-public.s3.ap-northeast-2.amazonaws.com/resource/fks/teaser/banner_1.png)] bg-cover bg-bottom p-5'>
              <div className='text-[13px] font-semibold leading-[100%] tracking-[-0.26px] text-[#78FFFB]'>
                PG / 서버 / 매출 등급별 수수료
              </div>
              <div className='mt-2 text-[21.5px] font-semibold leading-[100%] tracking-[-0.43px] text-[#FFF]'>
                이 모든 수수료가 0원!
              </div>
            </div>
          </div>
          <div className='flex flex-col justify-between rounded-[12px]'>
            <div className='flex w-full flex-col justify-between rounded-b-[12px] bg-white p-4 pt-6'>
              <div className='flex flex-col gap-3.5 pb-11'>
                <div className='text-[18px] font-semibold leading-[18px] tracking-[-0.36px] text-[#222222]'>
                  코딜몰 판매자 입점
                </div>
                <div className='break-words text-[16px] font-normal leading-[160%] tracking-[-0.32px] text-[#222222]'>
                  온라인에서 상품을 팔고 싶다면 안정적인 플랫폼과 다양한 서비스
                  연동을 경험해 보세요!
                </div>
              </div>

              <a
                href={'https://kodeal.fks.co.kr/m/sellerCenter/v2'}
                className='flex h-[50px] cursor-pointer flex-col items-center justify-center rounded-[8px] bg-[#222]'
              >
                <span className='text-center text-[15px] font-semibold leading-[100%] tracking-[-0.3px] text-[#FFF]'>
                  입점 라이선스 사전 예약하기
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Header() {
  const [isLogin, setIsLogin] = useState<boolean | null>(null);
  /** 로그인 회원 정보 가져오기 + setIsLogin */
  const getLoginUserInfo = async () => {
    return new Promise((rs, rj) => {
      fetch('https://kodeal.fks.co.kr/api/m/user', {
        method: 'GET',
        credentials: 'include',
      })
        .then((response) => {
          if (!response.ok) {
            setIsLogin(false);
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json(); // Parse JSON if the response is in JSON format
        })
        .then((data: any) => {
          if (data?.data) setIsLogin(true);
          else setIsLogin(false);
          return rs(data);
        })
        .catch((error) => {
          setIsLogin(false);
          console.error('Error fetching data:', error);
          return rs('');
        });
    });
  };
  useLayoutEffect(() => {
    getLoginUserInfo();
  }, []);

  return (
    <header className='bg-white px-5 sticky top-0 z-50 h-[56px]'>
      <div className='flex justify-between items-center gap-4 h-full max-w-[810px] mx-auto'>
        <Link
          to='https://kodeal.fks.co.kr'
          target='_blank'
          rel='noopener noreferrer'
          className='w-[163px] aspect-[163/32]'
        >
          <svg
            width='163'
            height='32'
            viewBox='0 0 163 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g clip-path='url(#clip0_3462_176956)'>
              <path
                d='M40.5784 11.3067V9.80409H43.3679V8.81445H45.2015V9.80409H48.0485V11.3067H47.0089C47.1918 11.545 47.3328 11.8093 47.4321 12.1046C47.5313 12.3999 47.5783 12.7108 47.5783 13.0424C47.5783 13.4725 47.4948 13.8663 47.3276 14.2238C47.1604 14.5813 46.9306 14.8922 46.638 15.1616C46.3455 15.431 46.0007 15.6331 45.5985 15.7834C45.1963 15.9336 44.7522 16.0062 44.2716 16.0062C43.791 16.0062 43.3679 15.9336 42.9761 15.7834C42.5843 15.6331 42.2396 15.431 41.947 15.172C41.6545 14.9129 41.4299 14.5968 41.2679 14.2341C41.106 13.8714 41.0276 13.4725 41.0276 13.0424C41.0276 12.7108 41.0746 12.3999 41.1739 12.1046C41.2731 11.8093 41.4142 11.545 41.597 11.3067H40.5836H40.5784ZM51.6112 11.5398H53.3611V13.0942H51.6112V21.0787H43.394C43.0597 21.0787 42.8194 21.001 42.6679 20.8455C42.5164 20.6901 42.4381 20.4777 42.4381 20.2134V16.7316H44.2716V19.5398H49.7828V9.27041H51.6164V11.5398H51.6112ZM44.2716 14.5139C44.4754 14.5139 44.6739 14.4725 44.8619 14.3948C45.05 14.317 45.2224 14.2134 45.3686 14.0839C45.5149 13.9543 45.6298 13.8041 45.7134 13.6227C45.797 13.4414 45.8388 13.2497 45.8388 13.0373C45.8388 12.8248 45.797 12.6176 45.7134 12.431C45.6298 12.2445 45.5149 12.0891 45.3686 11.9543C45.2224 11.8196 45.05 11.716 44.8619 11.6435C44.6739 11.5709 44.4754 11.5347 44.2716 11.5347C43.8485 11.5347 43.4881 11.6746 43.1955 11.9543C42.903 12.2341 42.7567 12.5968 42.7567 13.0373C42.7567 13.2497 42.7985 13.4414 42.8769 13.6227C42.9552 13.8041 43.0649 13.9543 43.2007 14.0839C43.3366 14.2134 43.4985 14.317 43.6813 14.3948C43.8642 14.4725 44.0575 14.5139 44.2716 14.5139Z'
                fill='#172A88'
              />
              <path
                d='M65.256 13.8968H65.9351V15.4408H61.218V16.6377H65.256V21.2336H63.4225V18.1921H55.3464V16.6377H59.3844V15.4408H54.6777V13.8968H63.4225V11.0056H55.3882V9.45117H64.4255C64.6866 9.45117 64.8904 9.51853 65.0366 9.65324C65.1829 9.78796 65.2613 9.97449 65.2613 10.2232V13.8968H65.256Z'
                fill='#172A88'
              />
              <path
                d='M77.8867 15.7685V14.2659H75.139C74.9352 14.5301 74.6793 14.7685 74.3763 14.9706C74.5069 14.9498 74.6375 14.9343 74.7733 14.9239C74.9091 14.9136 75.0449 14.9032 75.1807 14.9032C75.7345 14.9032 76.2516 14.9913 76.7218 15.1623C77.1919 15.3333 77.6046 15.5768 77.9494 15.8825C78.2942 16.1882 78.571 16.5561 78.7695 16.9757C78.968 17.3954 79.0673 17.8566 79.0673 18.354C79.0673 18.8514 78.968 19.2763 78.7695 19.696C78.571 20.1156 78.2994 20.4783 77.9494 20.784C77.5994 21.0897 77.1919 21.3333 76.7218 21.5146C76.2516 21.696 75.7345 21.784 75.1807 21.784C74.627 21.784 74.1308 21.696 73.6658 21.525C73.2009 21.354 72.8039 21.1053 72.4748 20.7944C72.1457 20.4835 71.8793 20.1208 71.6912 19.7063C71.5032 19.2918 71.4091 18.841 71.4091 18.3592C71.4091 17.7633 71.5397 17.2244 71.7957 16.7478C72.0517 16.2711 72.4121 15.8773 72.8666 15.5664C72.7569 15.5871 72.642 15.5975 72.5218 15.6079C72.4017 15.6182 72.2815 15.6234 72.1614 15.6234C71.6546 15.6234 71.1793 15.5457 70.7457 15.3851C70.3121 15.2244 69.936 15.0017 69.6226 14.7167C69.3091 14.4317 69.0584 14.0949 68.8808 13.7115C68.7032 13.3281 68.6091 12.9032 68.6091 12.4472C68.6091 11.9913 68.6979 11.5457 68.8703 11.1519C69.0427 10.7581 69.2935 10.4162 69.6069 10.126C69.9203 9.83585 70.2964 9.60787 70.73 9.44206C71.1636 9.27626 71.639 9.19336 72.1614 9.19336C72.7099 9.19336 73.2061 9.28144 73.6606 9.45243C74.1151 9.62341 74.5016 9.87212 74.8255 10.183H77.8919V9.27626H79.7255V15.7737H77.8919L77.8867 15.7685ZM72.1561 14.1156C72.386 14.1156 72.6106 14.0742 72.83 13.9913C73.0494 13.9084 73.2427 13.7892 73.4151 13.639C73.5875 13.4887 73.7233 13.3125 73.8225 13.1105C73.9218 12.9084 73.974 12.6856 73.974 12.4369C73.974 12.1882 73.9218 11.9447 73.8225 11.727C73.7233 11.5094 73.5875 11.3281 73.4203 11.1675C73.2531 11.0068 73.0599 10.8928 72.8352 10.8099C72.6106 10.727 72.386 10.6856 72.1561 10.6856C71.9263 10.6856 71.6912 10.727 71.477 10.8099C71.2629 10.8928 71.0748 11.012 70.9129 11.1675C70.7509 11.3229 70.6203 11.5094 70.5263 11.727C70.4323 11.9447 70.38 12.1778 70.38 12.4369C70.38 12.696 70.427 12.9136 70.5263 13.1208C70.6255 13.3281 70.7509 13.5042 70.9129 13.6493C71.0748 13.7944 71.2629 13.9084 71.477 13.9913C71.6912 14.0742 71.9158 14.1156 72.1561 14.1156ZM75.1807 20.2296C75.4472 20.2296 75.7084 20.1882 75.9591 20.1001C76.2098 20.012 76.4292 19.8877 76.6278 19.7219C76.8263 19.5561 76.9778 19.3592 77.0927 19.1312C77.2076 18.9032 77.2651 18.6441 77.2651 18.3592C77.2651 18.0586 77.2076 17.7892 77.0927 17.5561C76.9778 17.3229 76.821 17.126 76.6278 16.9654C76.4345 16.8048 76.2098 16.6856 75.9591 16.6027C75.7084 16.5198 75.4524 16.4783 75.1807 16.4783C74.9091 16.4783 74.674 16.5198 74.439 16.6079C74.2039 16.696 73.9949 16.8203 73.8121 16.9809C73.6293 17.1415 73.4882 17.3384 73.3733 17.5716C73.2584 17.8048 73.2061 18.069 73.2061 18.3643C73.2061 18.6597 73.2636 18.9084 73.3733 19.1364C73.483 19.3643 73.6293 19.5612 73.8121 19.727C73.9949 19.8928 74.1987 20.0172 74.439 20.1053C74.6793 20.1934 74.9248 20.2348 75.1807 20.2348V20.2296ZM75.7501 12.4369C75.7501 12.4939 75.7501 12.5457 75.7449 12.6027C75.7397 12.6597 75.7345 12.7063 75.724 12.7529H77.8867V11.6908H75.6666C75.724 11.9291 75.7501 12.1778 75.7501 12.4317V12.4369Z'
                fill='#172A88'
              />
              <path
                d='M91.7813 9.26972H93.6149V21.0832H85.3141C84.7291 21.0832 84.4418 20.8241 84.4418 20.3008V15.907H86.2753V16.9122H91.7865V13.0417H89.5402C89.4462 13.3837 89.2947 13.6998 89.0805 13.9899C88.8664 14.2801 88.6052 14.5392 88.297 14.7516C87.9888 14.964 87.6388 15.135 87.2574 15.2594C86.8761 15.3837 86.4634 15.4459 86.0298 15.4459C85.5231 15.4459 85.053 15.363 84.6194 15.1972C84.1858 15.0314 83.8149 14.8086 83.5015 14.5236C83.188 14.2386 82.9373 13.907 82.7597 13.534C82.5821 13.1609 82.488 12.7568 82.488 12.3371C82.488 11.9174 82.5768 11.4873 82.7492 11.1039C82.9216 10.7205 83.1724 10.3889 83.4858 10.1039C83.7992 9.81895 84.1753 9.59615 84.6037 9.43035C85.0321 9.26454 85.5074 9.18164 86.0246 9.18164C86.4477 9.18164 86.8552 9.23864 87.2313 9.35263C87.6074 9.46661 87.9522 9.62724 88.2604 9.83449C88.5686 10.0417 88.8246 10.2853 89.0387 10.5651C89.2529 10.8449 89.4096 11.1557 89.5089 11.4925H91.7865V9.26454L91.7813 9.26972ZM86.0194 13.9381C86.2492 13.9381 86.4738 13.8967 86.6932 13.8189C86.9126 13.7412 87.1059 13.6324 87.2783 13.4873C87.4507 13.3423 87.5865 13.1765 87.6962 12.9848C87.8059 12.793 87.8582 12.5754 87.8582 12.3371C87.8582 12.0987 87.8059 11.8656 87.6962 11.6635C87.5865 11.4614 87.4507 11.2853 87.2783 11.1402C87.1059 10.9951 86.9126 10.8811 86.688 10.8034C86.4634 10.7257 86.244 10.6842 86.0194 10.6842C85.7947 10.6842 85.5649 10.7257 85.3507 10.8034C85.1365 10.8811 84.9485 10.9951 84.7865 11.1402C84.6246 11.2853 84.494 11.4614 84.4 11.6635C84.3059 11.8656 84.2537 12.0884 84.2537 12.3371C84.2537 12.5858 84.3007 12.793 84.4 12.9899C84.4992 13.1868 84.6298 13.3526 84.797 13.4925C84.9641 13.6324 85.1522 13.736 85.3664 13.8138C85.5806 13.8915 85.7947 13.9329 86.0194 13.9329V13.9381ZM91.7813 18.4511H86.2701V19.5392H91.7813V18.4511Z'
                fill='#172A88'
              />
              <path
                d='M107.146 18.3433C107.146 18.82 107.047 19.2656 106.848 19.6853C106.65 20.105 106.378 20.4677 106.028 20.7786C105.678 21.0895 105.271 21.3382 104.801 21.5143C104.33 21.6905 103.813 21.7838 103.26 21.7838C102.706 21.7838 102.21 21.6957 101.745 21.5143C101.28 21.333 100.883 21.0946 100.554 20.7838C100.224 20.4729 99.958 20.1154 99.77 19.6957C99.5819 19.276 99.4879 18.8252 99.4879 18.3382C99.4879 17.649 99.655 17.0428 99.9894 16.5143C100.324 15.9858 100.778 15.5765 101.363 15.2812H101.264V11.1516H96.3901V9.59723H102.194C102.795 9.59723 103.098 9.86148 103.098 10.3952V10.4781H105.652V9.26562H107.486V15.7475H105.929C106.315 16.0687 106.618 16.4522 106.833 16.8926C107.047 17.333 107.151 17.8148 107.151 18.3382L107.146 18.3433ZM103.26 20.2294C103.526 20.2294 103.787 20.1879 104.038 20.0998C104.289 20.0117 104.508 19.8874 104.707 19.7216C104.905 19.5558 105.057 19.3589 105.171 19.1205C105.286 18.8822 105.344 18.6283 105.344 18.3433C105.344 18.0428 105.286 17.7734 105.171 17.5402C105.057 17.3071 104.9 17.105 104.707 16.9392C104.513 16.7734 104.289 16.649 104.038 16.561C103.787 16.4729 103.531 16.4314 103.26 16.4314C102.988 16.4314 102.753 16.4781 102.518 16.5713C102.283 16.6646 102.074 16.7941 101.891 16.9547C101.708 17.1154 101.567 17.3174 101.452 17.5558C101.337 17.7941 101.285 18.0532 101.285 18.3485C101.285 18.6439 101.342 18.8926 101.452 19.1257C101.562 19.3589 101.708 19.561 101.891 19.7268C102.074 19.8926 102.277 20.0169 102.518 20.105C102.758 20.1931 103.004 20.2345 103.26 20.2345V20.2294ZM105.647 11.9547H103.092V12.7112H105.647V11.9547ZM103.26 14.8615C103.724 14.8615 104.153 14.9237 104.555 15.048C104.957 15.1724 105.323 15.3433 105.647 15.5661V14.2294H103.092V14.8615H103.26Z'
                fill='#172A88'
              />
              <path
                d='M114.016 11.2812L116.722 16.4314L115.045 17.2967L113.06 13.333L111.049 17.2967L109.398 16.4314L112.078 11.2812H110.025V9.72677H116.074V11.2812H114.021H114.016ZM117.166 9.27081H118.958V21.0946H117.166V13.8926H115.447V12.3382H117.166V9.26562V9.27081ZM119.762 9.27081H121.606V21.0946H119.762V9.27081Z'
                fill='#172A88'
              />
              <path
                d='M127.66 9.21289C128.178 9.21289 128.663 9.29579 129.113 9.4616C129.562 9.6274 129.948 9.85538 130.278 10.1507C130.607 10.4461 130.863 10.7932 131.045 11.1973C131.228 11.6015 131.322 12.0419 131.322 12.5186C131.322 12.9953 131.228 13.4046 131.04 13.7984C130.852 14.1922 130.591 14.5393 130.257 14.8295C129.922 15.1196 129.536 15.3528 129.092 15.5186C128.648 15.6844 128.172 15.7673 127.66 15.7673C127.148 15.7673 126.678 15.6844 126.239 15.5134C125.801 15.3424 125.419 15.1144 125.095 14.8243C124.772 14.5341 124.516 14.1922 124.333 13.7984C124.15 13.4046 124.056 12.9745 124.056 12.5186C124.056 12.0626 124.145 11.617 124.328 11.2181C124.51 10.8191 124.761 10.472 125.085 10.1714C125.409 9.87092 125.79 9.63776 126.229 9.46678C126.668 9.29579 127.148 9.21289 127.666 9.21289H127.66ZM127.66 14.2647C127.927 14.2647 128.178 14.2181 128.407 14.1248C128.637 14.0315 128.836 13.9072 129.003 13.7518C129.17 13.5963 129.301 13.4098 129.4 13.2025C129.499 12.9953 129.546 12.7621 129.546 12.5134C129.546 12.2647 129.499 12.016 129.4 11.7932C129.301 11.5704 129.17 11.3787 128.998 11.2233C128.825 11.0678 128.627 10.9435 128.392 10.8502C128.157 10.7569 127.916 10.7103 127.655 10.7103C127.394 10.7103 127.154 10.7569 126.934 10.8502C126.715 10.9435 126.516 11.0678 126.349 11.2233C126.182 11.3787 126.051 11.5704 125.963 11.7932C125.874 12.016 125.822 12.2595 125.822 12.5134C125.822 12.7673 125.869 12.9901 125.963 13.2025C126.057 13.415 126.182 13.6015 126.344 13.7621C126.506 13.9227 126.699 14.0471 126.919 14.1352C127.138 14.2233 127.384 14.2647 127.655 14.2647H127.66ZM133.422 9.26988H135.256V21.0834H127.039C126.694 21.0834 126.454 21.0108 126.302 20.8709C126.151 20.731 126.078 20.5238 126.078 20.2595V16.6274H127.911V19.5445H133.422V9.27507V9.26988Z'
                fill='#172A88'
              />
              <path
                d='M138.056 11.3067V9.80409H140.762V8.81445H142.595V9.80409H145.343V11.0424H147.286V9.26523H149.12V21.0787H140.861C140.25 21.0787 139.947 20.7937 139.947 20.2238V16.0787H141.781V16.9854H147.292V14.8248H145.291V13.3378H147.292V12.5243H145.291V11.3015H144.486C144.617 11.5139 144.716 11.7419 144.784 11.9906C144.852 12.2393 144.889 12.4984 144.889 12.773C144.889 13.1771 144.81 13.5502 144.654 13.8974C144.497 14.2445 144.278 14.545 143.995 14.8041C143.713 15.0632 143.374 15.2704 142.982 15.4155C142.59 15.5606 142.151 15.6383 141.671 15.6383C141.19 15.6383 140.767 15.5657 140.381 15.4155C139.994 15.2652 139.66 15.0632 139.383 14.8041C139.106 14.545 138.887 14.2393 138.73 13.8974C138.573 13.5554 138.495 13.1771 138.495 12.773C138.495 12.2238 138.631 11.7316 138.897 11.3015H138.066L138.056 11.3067ZM141.666 14.115C141.859 14.115 142.047 14.0787 142.23 14.0113C142.413 13.944 142.564 13.8507 142.695 13.7316C142.825 13.6124 142.93 13.4725 143.008 13.3119C143.086 13.1512 143.128 12.9751 143.128 12.7834C143.128 12.3792 142.987 12.0528 142.7 11.7989C142.413 11.545 142.073 11.4207 141.671 11.4207C141.478 11.4207 141.295 11.4569 141.122 11.5243C140.95 11.5917 140.798 11.6849 140.673 11.8041C140.548 11.9233 140.443 12.0632 140.37 12.229C140.297 12.3948 140.26 12.5761 140.26 12.7782C140.26 12.9803 140.297 13.1512 140.37 13.317C140.443 13.4828 140.548 13.6227 140.673 13.7367C140.798 13.8507 140.955 13.944 141.122 14.0113C141.289 14.0787 141.478 14.115 141.671 14.115H141.666ZM147.286 18.5347H141.775V19.5398H147.286V18.5347Z'
                fill='#172A88'
              />
              <path
                d='M163.001 21.0778H161.167V18.6115H151.618V17.0675H154.716V15.8861C154.366 15.8032 154.042 15.6685 153.75 15.4872C153.457 15.3058 153.206 15.0882 152.992 14.8343C152.778 14.5804 152.611 14.3006 152.491 13.9897C152.37 13.6789 152.308 13.3473 152.308 13.0001C152.308 12.4043 152.48 11.8654 152.82 11.3887H151.806V9.87576H154.705V8.89648H156.539V9.87576H159.438V11.3887H158.409C158.754 11.855 158.921 12.3939 158.921 13.0001C158.921 13.3473 158.858 13.6789 158.738 13.9846C158.618 14.2903 158.451 14.5701 158.237 14.8188C158.023 15.0675 157.772 15.2799 157.479 15.4613C157.187 15.6426 156.873 15.7773 156.529 15.8654V17.0778H161.152V9.27472H162.985V21.0882L163.001 21.0778ZM155.599 14.4716C155.792 14.4716 155.985 14.4353 156.173 14.368C156.361 14.3006 156.534 14.2022 156.68 14.0726C156.826 13.9431 156.946 13.7877 157.035 13.6063C157.124 13.425 157.166 13.2229 157.166 13.0001C157.166 12.7773 157.124 12.5649 157.035 12.3783C156.946 12.1918 156.832 12.0364 156.68 11.912C156.529 11.7877 156.367 11.684 156.179 11.6167C155.991 11.5493 155.797 11.5131 155.594 11.5131C155.39 11.5131 155.197 11.5493 155.008 11.6167C154.82 11.684 154.664 11.7825 154.523 11.912C154.382 12.0416 154.272 12.197 154.188 12.3783C154.105 12.5597 154.063 12.767 154.063 13.0001C154.063 13.4405 154.209 13.798 154.507 14.0675C154.805 14.3369 155.165 14.4716 155.588 14.4716H155.599Z'
                fill='#172A88'
              />
              <path
                d='M-0.0012207 16L6.8577 22.8031C6.8577 22.8031 8.28904 24.1969 8.3674 24.2642C8.96292 24.7876 9.5062 25.1813 10.0077 25.4767C12.8338 27.1244 14.2442 25.5078 14.751 25.0311L16.7465 23.0518L9.63157 16H-0.0012207Z'
                fill='#009DDA'
              />
              <path
                d='M32.652 16.0008L25.7931 9.19769C25.7931 9.19769 24.3617 7.80391 24.2834 7.73655C23.6878 7.21324 23.1446 6.81945 22.6431 6.52412C19.817 4.87645 18.4065 6.49303 17.8998 6.96971L15.9043 8.94899L23.0192 16.0008H32.652Z'
                fill='#009DDA'
              />
              <path
                d='M17.2317 28.1913C16.7303 28.6939 15.5288 29.8908 13.5437 29.4607C14.6773 30.5851 16.5056 30.6939 17.7123 29.6524C17.9004 29.4918 18.0571 29.3312 18.1877 29.1965C18.2504 29.1291 18.3079 29.0721 18.3549 29.0307L28.4578 18.8701V16.9219L17.3676 28.0618C17.3258 28.1032 17.284 28.1447 17.2317 28.1913Z'
                fill='url(#paint0_linear_3462_176956)'
              />
              <path
                d='M18.7277 29.7205C18.2315 30.2231 17.1136 31.3681 15.3479 31.2542C16.3457 32.2438 17.9703 32.2438 18.968 31.2542L28.4546 21.7049V19.9277L18.8792 29.565C18.8322 29.6117 18.78 29.6583 18.7277 29.7205Z'
                fill='url(#paint1_linear_3462_176956)'
              />
              <path
                d='M15.2065 25.7053C14.611 26.2805 12.9498 27.8919 9.8103 25.7623L11.6334 27.5706C12.1297 28.0629 12.7252 28.4566 13.3991 28.6587C15.1648 29.1976 16.173 28.1872 16.6953 27.6691C16.7476 27.6173 16.7946 27.5654 16.8364 27.5292L22.3893 22.0214L24.0871 20.3375L28.4542 16.0059H16.3245L20.655 20.3012L15.2013 25.7105L15.2065 25.7053Z'
                fill='url(#paint2_linear_3462_176956)'
              />
              <path
                d='M15.4209 3.80832C15.9224 3.30573 17.1239 2.10884 19.1089 2.53889C17.9754 1.41454 16.147 1.30573 14.9403 2.34718C14.7522 2.5078 14.5955 2.66842 14.4649 2.80314C14.4022 2.87049 14.3448 2.92749 14.2978 2.96894L4.19482 13.1296V15.0777L15.2903 3.93785C15.3321 3.8964 15.3739 3.85495 15.4261 3.80832H15.4209Z'
                fill='url(#paint3_linear_3462_176956)'
              />
              <path
                d='M13.9269 2.27981C14.4231 1.77722 15.541 0.632145 17.3067 0.746134C16.3089 -0.243503 14.6843 -0.243503 13.6866 0.746134L4.19482 10.2954V12.0726L13.7702 2.43525C13.8172 2.38862 13.8694 2.34199 13.9216 2.27981H13.9269Z'
                fill='url(#paint4_linear_3462_176956)'
              />
              <path
                d='M17.4462 6.29461C18.0417 5.71948 19.7029 4.10808 22.8424 6.23761L21.0193 4.42932C20.523 3.9371 19.9275 3.54331 19.2536 3.34124C17.488 2.80238 16.4798 3.81274 15.9574 4.33088C15.9051 4.38269 15.8581 4.43451 15.8163 4.47078L10.2634 9.97855L8.56563 11.6625L4.19849 15.9941H16.3283L11.9977 11.6988L17.4514 6.28943L17.4462 6.29461Z'
                fill='url(#paint5_linear_3462_176956)'
              />
            </g>
            <defs>
              <linearGradient
                id='paint0_linear_3462_176956'
                x1='27.763'
                y1='17.5281'
                x2='13.5407'
                y2='31.8671'
                gradientUnits='userSpaceOnUse'
              >
                <stop stop-color='#172A88' />
                <stop offset='0.5' stop-color='#036EB8' />
                <stop offset='0.95' stop-color='#008ED2' />
              </linearGradient>
              <linearGradient
                id='paint1_linear_3462_176956'
                x1='29.3844'
                y1='19.135'
                x2='15.1621'
                y2='33.474'
                gradientUnits='userSpaceOnUse'
              >
                <stop stop-color='#172A88' />
                <stop offset='0.5' stop-color='#036EB8' />
                <stop offset='0.95' stop-color='#008ED2' />
              </linearGradient>
              <linearGradient
                id='paint2_linear_3462_176956'
                x1='24.3117'
                y1='14.0991'
                x2='10.0842'
                y2='28.4434'
                gradientUnits='userSpaceOnUse'
              >
                <stop stop-color='#172A88' />
                <stop offset='0.5' stop-color='#036EB8' />
                <stop offset='0.95' stop-color='#008ED2' />
              </linearGradient>
              <linearGradient
                id='paint3_linear_3462_176956'
                x1='6.39407'
                y1='12.9793'
                x2='19.9998'
                y2='-0.738089'
                gradientUnits='userSpaceOnUse'
              >
                <stop stop-color='#172A88' />
                <stop offset='0.5' stop-color='#036EB8' />
                <stop offset='0.95' stop-color='#008ED2' />
              </linearGradient>
              <linearGradient
                id='paint4_linear_3462_176956'
                x1='4.77467'
                y1='11.3731'
                x2='18.3804'
                y2='-2.34431'
                gradientUnits='userSpaceOnUse'
              >
                <stop stop-color='#172A88' />
                <stop offset='0.5' stop-color='#036EB8' />
                <stop offset='0.95' stop-color='#008ED2' />
              </linearGradient>
              <linearGradient
                id='paint5_linear_3462_176956'
                x1='9.8507'
                y1='16.4034'
                x2='23.4513'
                y2='2.69125'
                gradientUnits='userSpaceOnUse'
              >
                <stop stop-color='#172A88' />
                <stop offset='0.5' stop-color='#036EB8' />
                <stop offset='0.95' stop-color='#008ED2' />
              </linearGradient>
              <clipPath id='clip0_3462_176956'>
                <rect width='163' height='32' fill='white' />
              </clipPath>
            </defs>
          </svg>
        </Link>

        {isLogin === true ? (
          <Link
            to='https://kodeal.fks.co.kr'
            target='_blank'
            className='text-center text-[14px] leading-[14px] font-[500] py-[10px] h-[36px] w-[120px] px-[5px] rounded-[10px] border border-[#E5E5EC]'
          >
            코딜홈 바로가기
          </Link>
        ) : (
          isLogin === false && (
            <Link
              to='https://kodeal.fks.co.kr/login'
              target='_blank'
              rel='noopener noreferrer'
              className={cn(
                'text-[16px] leading-[16px] font-[500] text-[#172A88]',
                isLogin === null && 'hidden',
              )}
            >
              로그인
            </Link>
          )
        )}
      </div>
    </header>
  );
}

export default function MLandingPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  return (
    <div id='Landing' className='h-dvh overflow-y-scroll'>
      <Header />
      <Section1 />

      <GETSection02 />
      <GETSection03 />
      <div className='my-8 px-5'>
        <GETKodealCardBanner />
      </div>

      <Section3 />
      <GoTopBtn />
    </div>
  );
}
